export default __webpack_public_path__ + "static/media/paper.8b4616b5.svg";